// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"About_aboutContainer__2_yfi","box":"About_box__3kmAx","aboutContent":"About_aboutContent__WT4S2","title":"About_title__2ptNG"};